import React, { useState } from "react";
import axios from "axios";
import { Footer, Navbar } from "../components";
import configData from "../config.json";
import { useNavigate } from "react-router-dom";

const ChangePassword = () => {

  const navigate = useNavigate();

  // =========================
  // States
  // =========================

  const [changeData, setChangeData] = useState({
    emailId: "",
    oldpassword: "",
    newpassword: "",
    confirmpassword: ""
  });

  const [resetData, setResetData] = useState({
    resetemailId: ""
  });

  const [loading, setLoading] = useState(false);
  const [message,setMessage]=useState("New Password will be sent to your email.");

  // =========================
  // Handle Input
  // =========================

  const handleChangeInput = (e) => {

    const { name, value } = e.target;

    setChangeData(prev => ({
      ...prev, [name]: value
    }));
  };

  const handleResetInput = (e) => {

    const { name, value } = e.target;

    setResetData(prev => ({
      ...prev,[name]: value
    }));
  };

  // =========================
  // Change Password
  // =========================

  const handleChangePassword = async (e) => {

    e.preventDefault();

    // Confirm Password Validation
    if (
      changeData.newpassword !== changeData.confirmpassword ) {
      alert("New Password and Confirm Password do not match");
      return;
    }

    try {

      setLoading(true);

      const res = await axios.post(`${configData.SERVER_URL}/changepassword`,changeData);
      if(res.data.success){
        alert(res.data.message);
        navigate('/login');
      }
      // Reset Form
    //   setChangeData({
    //     emailId: "",
    //     oldpassword: "",
    //     newpassword: "",
    //     confirmpassword: ""
    //   });

    } catch (err) {

      console.error(err);
      alert( err?.response?.data?.message || "System Error" );

    } finally {
      setLoading(false);
    }
  };

  // =========================
  // Reset Password
  // =========================

  const handleResetPassword = async (e) => {

    e.preventDefault();

    try {

      setLoading(true);

      const res = await axios.post(`${configData.SERVER_URL}/forgetpassword`,resetData );
      
      if(res.data.success){
        setMessage(res.data.message);
        setResetData({ resetemailId: ""});
      }

    } catch (err) {

      console.error(err);

      alert(
        err?.response?.data?.message ||
        "System Error"
      );

    } finally {

      setLoading(false);
    }
  };

  // =========================
  // Render
  // =========================

  return (
    <>
    <Navbar/>
    <div className="container py-5">

      <div className="row justify-content-center">

        <div className="col-lg-8">

          {/* Reset Password */}

          <div className="card shadow mb-4">

            <div className="card-header bg-secondary text-white">
              <h5 className="mb-0"> Reset Password </h5>
            </div>

            <div className="card-body">

              <form onSubmit={handleResetPassword}>

                <div className="mb-3">
                  <label className="form-label">
                    Valid E-mail Address
                  </label>

                  <input type="email" className="form-control" name="resetemailId" value={resetData.resetemailId} 
                    onChange={handleResetInput} required
                  />
                </div>

                <button type="submit" className="btn btn-warning" disabled={loading}>
                  {
                    loading
                    ? "Processing..."
                    : "Reset Password"
                  }
                </button>

                <div className="mt-3 text-muted">
                  {message}
                </div>

              </form>

            </div>

          </div>

          {/* Change Password */}

          <div className="card shadow mb-4">

            <div className="card-header bg-info text-white">
              <h5 className="mb-0">
                Change Password
              </h5>
            </div>

            <div className="card-body">

              <form onSubmit={handleChangePassword}>

                {/* Email */}

                <div className="mb-3">

                  <label className="form-label">
                    Valid E-mail Address
                  </label>

                  <input
                    type="email"
                    className="form-control"
                    name="emailId"
                    value={changeData.emailId}
                    onChange={handleChangeInput}
                    required
                  />

                </div>

                {/* Old Password */}

                <div className="mb-3">

                  <label className="form-label">
                    Old Password
                  </label>

                  <input
                    type="password"
                    className="form-control"
                    name="oldpassword"
                    value={changeData.oldpassword}
                    onChange={handleChangeInput}
                    required
                  />

                </div>

                {/* New Password */}

                <div className="mb-3">

                  <label className="form-label">
                    New Password
                  </label>

                  <input
                    type="password"
                    className="form-control"
                    name="newpassword"
                    value={changeData.newpassword}
                    onChange={handleChangeInput}
                    required
                  />

                </div>

                {/* Confirm Password */}

                <div className="mb-3">

                  <label className="form-label">
                    Confirm Password
                  </label>

                  <input
                    type="password"
                    className="form-control"
                    name="confirmpassword"
                    value={changeData.confirmpassword}
                    onChange={handleChangeInput}
                    required
                  />

                </div>

                {/* Password Match Message */}

                {
                  changeData.confirmpassword &&
                  (
                    changeData.newpassword ===
                    changeData.confirmpassword
                  )
                  ? (
                    <div className="text-success mb-3">
                      Password matched
                    </div>
                  )
                  : (
                    changeData.confirmpassword &&
                    <div className="text-danger mb-3">
                      Password not matched
                    </div>
                  )
                }

                {/* Submit */}

                <button
                  type="submit"
                  className="btn btn-info"
                  disabled={loading}
                >
                  {
                    loading
                    ? "Processing..."
                    : "Change Password"
                  }
                </button>

              </form>

            </div>

          </div>

          

        </div>

      </div>

    </div>
    <Footer/>
    </>
  );
};

export default ChangePassword;